/** 名前の頭文字の丸(写真は持たないので代わり)。 */
export function Initials({ name, size = "md" }: { name: string; size?: "sm" | "md" | "lg" }) {
  const text = (name ?? "").trim();
  const parts = text.split(/\s+/).filter(Boolean);
  const label =
    parts.length >= 2 ? `${parts[0][0] ?? ""}${parts[1][0] ?? ""}` : text.slice(0, 2) || "?";
  return (
    <span className={`ui-avatar ui-avatar--${size}`} aria-hidden>
      {label}
    </span>
  );
}
